import filterIngredients from "./filterIngredients";
import multiplyIngredients from "./multiplyIngredients";
import updateUnits from "./updateUnits";

export default function reduceIngredients(ingredients, settings, config) {
  // destructure settings
  const { baseServingSize, filterId } = settings;
  // destructure config
  const { servings, units, filter } = config;

  // if there is a filterId, filter the ingredients
  const filteredIngredients = filterId ? 
    filterIngredients(ingredients, filterId, filter)
    : ingredients;

  // multiply the ingredient "number" based on selected "servings"
  const multipliedIngredients = multiplyIngredients(filteredIngredients, servings, baseServingSize)

  // update "number" and "unit" with appropriate values based on selected "units"
  return updateUnits(multipliedIngredients, units);
}